module.exports = {
	methods: {
		smoothScroll: function(target){
			var position = $(target).offset().top;
			$('body, html').animate({ scrollTop: position }, 400, 'swing');
		}
	}
};



// WEBPACK FOOTER //
// ./src/mixins/smoothScroll.js